import { ArrowDownward, ArrowUpward, HorizontalRule } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface DeltaValueProps {
  delta?: number
  positiveColor: string
}

const ICON_SIZE = 20

const DeltaValue: React.FC<DeltaValueProps> = ({ delta, positiveColor }) => {
  const { formatNumber } = useIntl()

  if (delta === undefined)
    return (
      <Typography variant="subtitle1" color="text.disabled">
        —
      </Typography>
    )

  const color = delta > 0 ? positiveColor : delta < 0 ? 'semantic.error' : 'text.disabled'
  const Icon = delta > 0 ? ArrowUpward : delta < 0 ? ArrowDownward : HorizontalRule

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" color={color}>
      <Icon aria-hidden sx={{ fontSize: ICON_SIZE }} />
      <Typography
        variant="subtitle1"
        color="inherit"
        aria-label={formatNumber(delta, { maximumFractionDigits: 1, signDisplay: 'exceptZero' })}
      >
        {formatNumber(Math.abs(delta), { maximumFractionDigits: 1 })}
      </Typography>
    </Stack>
  )
}

export default DeltaValue
